var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.127 11.769a.83.83 0 0 1-.578.231.83.83 0 0 1-.577-.231L.359 7.313a1.155 1.155 0 0 1 0-1.674l.578-.558a1.256 1.256 0 0 1 1.732 0l2.88 2.782L13.331.347a1.256 1.256 0 0 1 1.732 0l.578.558a1.155 1.155 0 0 1 0 1.673z"
  })));
};
export default SvgCheck;